<template>
  <div>
    <div style="display: flex; overflow: auto" id="column-list">
      <div v-for="(item, index) in list" class="column-item" ref="dd" :key="item.id" :class="{ active: index === num }"
        :style="handleStyle(item)" @click="getActive(item)">
        <!-- {{ item }} -->
        <div class="label" :title="item.name">
          <span v-show="(item.required)" class="required-icon">*</span>
          {{ item.name }}
        </div>
        <div></div>
        <div class="el-icon-circle-close del-icon" @click.stop="delColumn(index)" v-if="showClose"></div>
      </div>
    </div>

    <div v-show="list.length" class="table-content">暂无数据</div>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  data() {
    return {
      tableData: [],
      tempId: ''
      // list: [],
    };
  },
  props: {
    columnList: {
      type: Array,
      default: () => [],
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    hasSort: {
      type: Boolean,
      default: true,
    },
  },

  // watch: {
  //   columnList: {
  //     handler(newVal) {
  //       console.log('配置对象发生了变化：', newVal);
  //       const columnClass = {
  //         width: "120px",
  //         background: "#eee",
  //       };
  //       this.list = newVal.map(i => {
  //         i.columnClass = columnClass
  //         return i
  //       })
  //     },
  //     immediate: true,
  //     deep: true // 开启对 config 对象的深度监视

  //   },
  // },
  computed: {
    list() {
      const columnClass = {
        width: "120px",
        background: "#eee",
      };

      const list = this.columnList.map((i) => {
        console.log(i);

        i.columnClass = columnClass;
        return i;
      });
      return list;
    },
    num() {
      if (this.tempId === '') {
        return '-'
      }
      const index = this.list.findIndex(i => i.id === this.tempId)
      return index
    },
    closeIcon(index) {
      return this.showClose;
    },
  },
  mounted() {
    const el = document.getElementById("column-list");
    if (!el) {
      return;
    }
    const sort = this.hasSort,
      getxx = this.getSort;
    new Sortable(el, {
      group: {
        name: "shared",
        put: false, // 不允许拖拽进这个列表
      },
      animation: 150,
      sort: sort, // 设为false，禁止sort
      onMove: (event) => {
        const { dragged, related, willInsertAfter } = event;
        const { _prevClass: drag_class, id } = dragged,
          { _prevClass: related_class } = related;

        if (!related_class) {
          return false
        }

      },
      onEnd: (list) => {
        getxx(list);
      },
    });
  },
  methods: {
    getSort({ oldIndex, newIndex }) {
      // const [curr] = this.list.splice(oldIndex, 1);
      // this.list.splice(newIndex, 0, curr);
      // const list = this.list.map((i, e) => {
      //   const id = i.id,
      //     attrOrder = 21 + e;
      //   return [id, attrOrder];
      // });

      this.$emit("sort", { oldIndex, newIndex });

      // if (this.tempId === '') {
      //   return
      // }


    },

    handleStyle(item) { },
    getActive(item) {
      this.tempId = item.id
      this.$emit("setActive", { id: item.id });
    },

    delConfirm() {
      return this.$confirm(this.$t("message.confirm.deleteData"));
    },

    delColumn(index) {
      if (this.num !== index) {
        return;
      }


      this.delConfirm().then((res) => {
        this.tempId = ''
        this.$emit("setActive", { id: "" });

        this.$emit("delColumn", index);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.column-item {
  flex: 1;
  font-size: 12px;
  width: 120px;
  //   background-color: #eee;
  padding: 8px 6px;
  border: 1px solid #eee;
  cursor: pointer;

  display: flex;
  align-items: center;

  &:not(:first-child) {
    border-left: none;
  }

  &.active {
    color: #eee;
    background-color: var(--themeColor);

    span {
      color: #eee;
    }
  }

  .label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .del-icon {
    margin-left: auto;
    margin-right: 5px;
    color: #fff;
  }
}

.required-icon {
  color: red;
}

.table-content {
  padding: 15px;
  font-size: 12px;
  text-align: center;
  border: 1px solid #eee;
  border-top: none;
  color: #909399;
}
</style>